// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Col from '@tcp/core/src/components/common/atoms/Col';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import Image from '@tcp/core/src/components/common/atoms/Image';
import internalEndpoints from '../../../../../internalEndpoints';
import { getIconPath } from '../../../../../../../../../utils';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../../../utils/labels/labelUtilty';
import {
  GLOBAL_ACTIONS_LABELS,
  GlobalActionsLabels,
  lblEdit,
} from '../../../../../../../../../utils/labels/globalActions.labels';
import AccountCommonLabels, { ACCOUNT_LABELS } from '../../../../../labels/AccountCommon.labels';

const ContactPreferencesTileItem = ({ customerPreferences }) => {
  const accountLabels = getLabelFromCopyOrFromTranslation(ACCOUNT_LABELS, AccountCommonLabels);

  const { placeRewardsPush, placeRewardsSms } = customerPreferences;
  const addEditText =
    placeRewardsPush || placeRewardsSms
      ? renderLabel(
          getLabelFromCopyOrFromTranslation(
            `${GLOBAL_ACTIONS_LABELS}.${lblEdit}`,
            GlobalActionsLabels
          ),
          'lbl_edit'
        )
      : renderLabel(accountLabels?.preferences?.lbl_preference_tileAdd, 'lbl_preference_tileAdd');
  return (
    <BodyCopy component="div" className="heading elem-pt-LRG">
      <Row fullBleed>
        <Col
          colSize={{
            small: 3,
            large: 6,
            medium: 4,
          }}
        >
          <BodyCopy component="div" fontSize="fs14" fontWeight="extrabold" fontFamily="secondary">
            {renderLabel(
              accountLabels?.preferences?.lbl_preference_tileContactPreference,
              'lbl_preference_tileContactPreference'
            )}
          </BodyCopy>
        </Col>
        <Col
          colSize={{
            small: 3,
            large: 6,
            medium: 4,
          }}
        >
          <Row fullBleed>
            <Col
              colSize={{
                small: 2,
                large: 5,
                medium: 2,
              }}
            >
              {placeRewardsSms ? (
                <Image
                  className="elem-pr-SM"
                  width="30"
                  height="30"
                  src={getIconPath('sms-enabled')}
                  alt={'lbl_sms_enabled_icon'}
                />
              ) : (
                <Image
                  className="elem-pr-SM"
                  width="30"
                  height="30"
                  src={getIconPath('sms-disabled')}
                  alt={'lbl_sms_disabled_icon'}
                />
              )}
              <BodyCopy
                component="div"
                fontSize="fs10"
                fontWeight="extrabold"
                fontFamily="secondary"
              >
                {renderLabel(
                  accountLabels?.preferences?.lbl_preference_tileTextText,
                  'lbl_preference_tileTextText'
                )}
              </BodyCopy>
            </Col>
            <Col
              colSize={{
                small: 2,
                large: 5,
                medium: 2,
              }}
            >
              {placeRewardsPush ? (
                <Image
                  className="elem-pr-SM"
                  width="30"
                  height="30"
                  src={getIconPath('push-enabled')}
                  alt={'lbl_push_enabled_icon'}
                />
              ) : (
                <Image
                  className="elem-pr-SM"
                  width="30"
                  height="30"
                  src={getIconPath('push-disabled')}
                  alt={'lbl_push_disabled_icon'}
                />
              )}
              <BodyCopy
                className="elem-pl-XXXS"
                component="div"
                fontSize="fs10"
                fontWeight="extrabold"
                fontFamily="secondary"
              >
                {renderLabel(
                  accountLabels?.preferences?.lbl_preference_tileAppText,
                  'lbl_preference_tileAppText'
                )}
              </BodyCopy>
            </Col>
            <Col
              colSize={{
                small: 2,
                large: 2,
                medium: 4,
              }}
            >
              <BodyCopy component="div" textAlign="right" fontSize="fs14" fontFamily="secondary">
                <Anchor
                  fontSizeVariation="large"
                  underline
                  anchorVariation="primary"
                  to={internalEndpoints.myPreferencesPage.link}
                  asPath={internalEndpoints.myPreferencesPage.path}
                  aria-label="Edit contact preferences"
                >
                  {addEditText}
                </Anchor>
              </BodyCopy>
            </Col>
          </Row>
        </Col>
      </Row>
    </BodyCopy>
  );
};

ContactPreferencesTileItem.propTypes = {
  customerPreferences: PropTypes.shape({}),
};

ContactPreferencesTileItem.defaultProps = {
  customerPreferences: {},
};

export default ContactPreferencesTileItem;
